import { Link } from 'react-router-dom';

import { NavigationTabButton } from 'shared/ui';
import { CAR_BRAND_ROUTES } from 'shared/consts/routes/car-brands';

export function AddCarModelButtonLink() {
  return (
    <Link to={CAR_BRAND_ROUTES.ADD_CAR_MODEL}>
      <NavigationTabButton title="Добавить модель" />
    </Link>
  );
}
